import api from '../../api'

export const statementRepairEndpoint = '/web/admin/statement-payments/repair'

export type StatementRepairResult = {
  statementCount: number
  invoiceCount: number
}

export const repairStatementPaidInvoices = async (): Promise<StatementRepairResult> => {
  return (await api.post(statementRepairEndpoint)).data
}
